import { useEffect, useRef, useState } from 'react'

export interface MehrEintrag {
  text: string
  aktion: () => void
  /** Loeschen und Aehnliches: rot beim Ueberfahren. */
  gefahr?: boolean
}

/**
 * Das Menue "···" fuer Seltenes. Was man oft braucht, steht als Knopf
 * daneben; was man selten braucht und was etwas kaputt machen kann
 * (Loeschen), gehoert nicht in eine Reihe mit PDF.
 */
export function Mehrmenue({ eintraege, name = 'Weitere Aktionen' }: { eintraege: MehrEintrag[]; name?: string }) {
  const [offen, setOffen] = useState(false)
  const bereich = useRef<HTMLDivElement>(null)
  const knopf = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!offen) return
    const beiKlick = (e: MouseEvent) => {
      if (!bereich.current?.contains(e.target as Node)) setOffen(false)
    }
    const beiTaste = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setOffen(false)
        knopf.current?.focus()
      }
    }
    document.addEventListener('mousedown', beiKlick)
    document.addEventListener('keydown', beiTaste)
    return () => {
      document.removeEventListener('mousedown', beiKlick)
      document.removeEventListener('keydown', beiTaste)
    }
  }, [offen])

  return (
    <div className="mehr" ref={bereich}>
      <button ref={knopf} type="button" className="knopf mehr-knopf" aria-label={name} aria-haspopup="menu" aria-expanded={offen} onClick={() => setOffen((o) => !o)}>
        ···
      </button>
      {offen && (
        <div className="profil-menue mehr-menue" role="menu">
          {eintraege.map((e) => (
            <button
              key={e.text}
              type="button"
              role="menuitem"
              className={`profil-eintrag${e.gefahr ? ' abmelden' : ''}`}
              onClick={() => {
                setOffen(false)
                e.aktion()
              }}
            >
              {e.text}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
